import { useState } from 'react'

export type ReceptionStep = 'choice' | 'new-patient' | 'existing-patient' | 'waiting-room' | 'done'

export type SelectedPatient = { id: string; label: string }

/** Step machine of the simplified reception: pick or create a patient, then a waiting room. */
export function useSimplifiedReception() {
  const [step, setStep] = useState<ReceptionStep>('choice')
  const [patient, setPatient] = useState<SelectedPatient>()
  const [waitingRoomName, setWaitingRoomName] = useState<string>()
  const [consultationId, setConsultationId] = useState<string>()

  const choosePatient = (selected: SelectedPatient) => {
    setPatient(selected)
    setStep('waiting-room')
  }

  const finish = (roomName: string, queuedConsultationId: string) => {
    setWaitingRoomName(roomName)
    setConsultationId(queuedConsultationId)
    setStep('done')
  }

  const restart = () => {
    setPatient(undefined)
    setWaitingRoomName(undefined)
    setConsultationId(undefined)
    setStep('choice')
  }

  return { step, patient, waitingRoomName, consultationId, start: setStep, choosePatient, finish, restart }
}
